import VueRouter from 'vue-router';
import get from 'lodash/get';

/**
 *
 * @param {VueRouter} vueRouter
 * @param {*} routesConfig
 * @returns {VueRouter}
 */
export function initRouter(vueRouter, routesConfig) {
    const routes = [];

    const files = require.context('./../vue/router', true, /\.routes.js$/i);
    files.keys().map((key) => {
        let route = files(key).default;
        let configRoute = get(routesConfig, ['routes', route.name], {});

        if (!configRoute.name && configRoute.children && configRoute.children.length)
        {
            //we have a custom route setup & we'll use it as it is
            route = configRoute;
        } else {
            route = {
                ...route,
                ...configRoute
            };
        }

        routes.push(route);
    });

    vueRouter.addRoutes(routes);

    return vueRouter;
}


